(function () {
  'use strict';
  /* The approval card in the window: Approve moves the demo to step 3 (the shared player does that through data-pl-go);
     Edit and Reject say what they do, and pause the demo so the message is not replaced under the reader. */
  var demo = document.querySelector('[data-uc-demo]');
  if (!demo) return;
  var msg = demo.querySelector('.uc-ap__msg');
  function say(t) { if (!msg) return; msg.textContent = t || ''; msg.hidden = !t; }
  demo.addEventListener('click', function (e) {
    var b = e.target.closest('[data-uc-act]');
    if (!b || !demo.contains(b)) return;
    var act = b.getAttribute('data-uc-act');
    if (act === 'approve') { say(''); return; }
    say(b.getAttribute('data-msg'));
    if (demo.__player) demo.__player.pause();
  });
  demo.addEventListener('pl:step', function () { say(''); });
})();
